module.exports = __webpack_public_path__ + "static/media/video-navidad-2020@2x.84b6bf9c.jpg";